import React, { useRef, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import Dropdown from '../../../../Components/Ui/Dropdown';
import Datepicker from '../../../../Components/Ui/Datepicker';
import Timepicker from '../../../../Components/Ui/Timepicker';
import dayjs from 'dayjs';
import BackClickBottomSheet from '../../../../Components/BottomSheet/BackClickBottomSheet';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ZoomableImage from '../../../../Components/Ui/ZoomableImage';

const MAX_PHOTOS = 5;

function WOR_DAI_02(props) {
  const {
    gubun,
    saveGubun = '1',
    gongjongList = [],
    Save1,
    isSaving,
    workInfoUpload,
    detailItem,
  } = props;

  if (gubun === 'risk')
    return (
      <RiskWrite
        gongjongList={gongjongList}
        Save1={Save1}
        isSaving={isSaving}
        saveGubun={saveGubun}
        workInfoUpload={workInfoUpload}
        detailItem={detailItem}
      />
    );
  if (gubun === 'nearMiss')
    return (
      <NearMissWrite
        gongjongList={gongjongList}
        Save1={Save1}
        isSaving={isSaving}
        workInfoUpload={workInfoUpload}
        detailItem={detailItem}
      />
    );

  return (
    <div className="flex h-full min-h-0 flex-1 items-center justify-center bg-[#f8fafc] px-6 text-center">
      <div>
        <p className="text-base font-bold text-slate-900">잘못된 접근입니다.</p>
        <p className="mt-2 text-sm text-slate-500">
          경로의 gubun 값이 올바르지 않습니다.
        </p>
      </div>
    </div>
  );
}

export default WOR_DAI_02;

function RiskWrite(props) {
  const {
    gongjongList,
    Save1,
    saveGubun = '1',
    workInfoUpload,
    detailItem,
    isSaving,
  } = props;
  const [gongjongCd, setGongjongCd] = useState(detailItem?.gongjongCd ?? '');
  const [reportDate, setReportDate] = useState(
    detailItem?.reportDate
      ? dayjs(detailItem.reportDate).format('YYYY-MM-DD')
      : dayjs().format('YYYY-MM-DD')
  );
  const [location, setLocation] = useState(detailItem?.location ?? '');
  const [content, setContent] = useState(detailItem?.content ?? '');
  const fileInputRef = useRef(null);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const routeLocation = useLocation();
  const { workCd: storeWorkCd } = useSelector((state) => state.workingCheck);
  const workCd = routeLocation.state?.workCd ?? storeWorkCd;

  const previewList = (workInfoUpload?.previewList ?? []).filter(
    (i) => !i.deleted
  );
  const photoCount = previewList.length;

  return (
    <div className="mx-auto flex min-h-full w-full max-w-md flex-col bg-[#f8fafc]">
      <main className="min-h-0 flex-1 space-y-6 overflow-y-auto p-4">
        <section className="space-y-2">
          <label className="ml-1 block text-sm font-semibold text-slate-700">
            공정명 <span className="text-red-500">*</span>
          </label>
          <Dropdown
            options={[...gongjongList, { name: '기타', value: '0' }]}
            value={gongjongCd}
            onChange={setGongjongCd}
            placeholder="선택하세요"
            triggerClassName="h-12 rounded-lg border border-slate-300 bg-white focus:border-transparent focus:ring-2 focus:ring-[#28a745]"
            selectedOptionClassName="bg-[#28a745]/10 text-[#28a745]"
          />
          <div className="flex items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
            <span className="material-symbols-outlined mt-0.5 text-sm text-slate-400">
              info
            </span>
            <p className="text-xs leading-relaxed text-slate-500">
              목록에 없는 공정은{' '}
              <span className="font-semibold text-slate-700">「기타」</span>를
              선택하고, 장소 항목에 구체적인 내용을 자세히 입력해 주세요.
            </p>
          </div>
        </section>

        <section className="space-y-2">
          <label className="ml-1 block text-sm font-semibold text-slate-700">
            제보일자 <span className="text-red-500">*</span>
          </label>
          <Datepicker
            id="risk-reportDate"
            value={reportDate}
            onChange={setReportDate}
            placeholder="날짜 선택 (YYYY-MM-DD)"
            format="yyyy-mm-dd"
            inputClassName="h-12 focus:border-transparent focus:ring-2 focus:ring-[#28a745] bg-white border border-slate-300"
            iconClassName="text-slate-400 group-focus-within:text-[#28a745]"
          />
        </section>

        <section className="space-y-2">
          <label className="ml-1 block text-sm font-semibold text-slate-700">
            장소 <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            placeholder="장소를 입력하세요"
            className="h-12 w-full rounded-lg border border-slate-300 bg-white px-4 transition-all outline-none placeholder:text-slate-400 focus:border-transparent focus:ring-2 focus:ring-[#28a745]"
          />
        </section>

        <section className="space-y-2">
          <label className="ml-1 block text-sm font-semibold text-slate-700">
            내용 및 대책 <span className="text-red-500">*</span>
          </label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="w-full resize-none rounded-lg border border-slate-300 bg-white p-4 transition-all outline-none placeholder:text-slate-400 focus:border-transparent focus:ring-2 focus:ring-[#28a745]"
            placeholder="발견하신 위험요인의 구체적인 내용과 예상되는 개선 대책을 입력해주세요."
            rows={5}
          />
        </section>

        <section className="space-y-2">
          <div className="ml-1 flex items-center justify-between">
            <label className="text-sm font-semibold text-slate-700">
              사진 첨부
            </label>
            <span className="text-xs text-slate-500">최대 {MAX_PHOTOS}장</span>
          </div>
          <div className="grid grid-cols-1 gap-3">
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              multiple
              className="hidden"
              onChange={(e) => workInfoUpload?.FileChange(e)}
            />
            <div
              role="button"
              tabIndex={0}
              onClick={() => {
                if (photoCount >= MAX_PHOTOS) return;
                if (Capacitor.isNativePlatform()) {
                  workInfoUpload?.NativeFileChange();
                } else {
                  fileInputRef.current?.click();
                }
              }}
              className="flex cursor-pointer flex-col items-center justify-center gap-3 rounded-xl border-2 border-dashed border-slate-300 bg-white px-6 py-10 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
              style={{
                pointerEvents: photoCount >= MAX_PHOTOS ? 'none' : undefined,
              }}
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#28a745]/10">
                <span className="material-symbols-outlined text-3xl text-[#28a745]">
                  add_a_photo
                </span>
              </div>
              <div className="text-center">
                <p className="text-sm font-bold text-slate-900">
                  사진 추가하기
                </p>
                <p className="mt-1 text-xs text-slate-500">
                  현장 사진을 촬영하거나 갤러리에서 선택하세요 ({photoCount}/
                  {MAX_PHOTOS})
                </p>
              </div>
            </div>

            {previewList.length > 0 && (
              <div className="flex flex-wrap gap-2 pb-2">
                {previewList.map((item, index) => (
                  <div
                    key={index}
                    className="relative h-20 w-20 shrink-0 overflow-hidden rounded-lg border border-slate-200 bg-slate-100"
                  >
                    <ZoomableImage
                      src={item.preview}
                      alt=""
                      className="h-full w-full object-cover"
                    />
                    <button
                      type="button"
                      onClick={() => workInfoUpload?.DeletePreview(item)}
                      className="absolute top-1 right-1 flex h-6 w-6 items-center justify-center rounded-full bg-black/50 text-white"
                    >
                      <span className="material-symbols-outlined text-sm">
                        close
                      </span>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <div className="flex gap-2 rounded-lg bg-blue-50 p-3">
          <span className="material-symbols-outlined text-sm text-blue-600">
            info
          </span>
          <p className="text-xs leading-tight text-blue-800">
            제보된 내용은 안전 관리팀으로 즉시 전달되며, 보완 조치 후 결과를
            앱에서 확인하실 수 있습니다.
          </p>
        </div>
      </main>

      <footer className="shrink-0 border-t border-slate-200 bg-white p-4">
        <button
          type="button"
          onClick={() =>
            Save1({
              nearMissSeq: detailItem?.nearMissSeq ?? null,
              gongjongCd,
              reportDate,
              location,
              content,
              workCd,
              gubun: saveGubun,
            })
          }
          disabled={isSaving}
          className={`flex h-14 w-full items-center justify-center gap-2 rounded-xl text-lg font-bold text-white shadow-lg transition-all ${
            isSaving
              ? 'cursor-wait bg-slate-400 opacity-70 shadow-none'
              : 'bg-[#28a745] shadow-[#28a745]/20 hover:bg-[#28a745]/90 active:scale-[0.98]'
          }`}
        >
          <span>
            {isSaving
              ? '처리 중...'
              : saveGubun === '3'
                ? '작업 종료하기'
                : '제보하기'}
          </span>
          <span className="material-symbols-outlined">send</span>
        </button>
      </footer>

      {bottomSheetState.type === 'backClickWor' && <BackClickBottomSheet />}
    </div>
  );
}

function NearMissWrite(props) {
  const { gongjongList, Save1, workInfoUpload, detailItem } = props;

  const initialOccur = detailItem?.occurDate ?? '';
  const initialDateObj = initialOccur ? dayjs(initialOccur) : dayjs();

  const [gongjongCd, setGongjongCd] = useState(detailItem?.gongjongCd ?? '');
  const [reportDate, setReportDate] = useState(
    detailItem?.reportDate
      ? dayjs(detailItem.reportDate).format('YYYY-MM-DD')
      : dayjs().format('YYYY-MM-DD')
  );
  const [occurDate, setOccurDate] = useState(
    initialDateObj.isValid()
      ? initialDateObj.format('YYYY-MM-DD')
      : dayjs().format('YYYY-MM-DD')
  );
  const [occurTime, setOccurTime] = useState(
    initialDateObj.isValid()
      ? initialDateObj.format('HH:mm')
      : dayjs().format('HH:mm')
  );
  const [location, setLocation] = useState(detailItem?.location ?? '');
  const [content, setContent] = useState(detailItem?.content ?? '');
  const fileInputRef = useRef(null);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const routeLocation = useLocation();
  const { workCd: storeWorkCd } = useSelector((state) => state.workingCheck);
  const workCd = routeLocation.state?.workCd ?? storeWorkCd;

  const previewList = (workInfoUpload?.previewList ?? []).filter(
    (i) => !i.deleted
  );
  const photoCount = previewList.length;

  return (
    <div className="mx-auto flex min-h-full w-full max-w-md flex-col bg-white shadow-xl">
      <main className="min-h-0 flex-1 space-y-6 overflow-y-auto p-4">
        <div className="flex items-start gap-3 rounded-xl border border-[#FF6B00]/20 bg-[#FF6B00]/5 p-4">
          <span className="material-symbols-outlined text-xl text-[#FF6B00]">
            info
          </span>
          <p className="text-sm leading-relaxed text-slate-600">
            앗! 사고가 날 뻔했나요? 유사 사고 방지를 위해{' '}
            <span className="font-semibold text-[#FF6B00]">
              아차 사고(Near Miss)
            </span>{' '}
            내용을 상세히 기록해 주세요.
          </p>
        </div>

        <div className="space-y-5">
          <div className="flex flex-col gap-2">
            <label className="flex items-center gap-1 text-sm font-semibold text-slate-700">
              공정명 <span className="text-[#FF6B00]">*</span>
            </label>
            <Dropdown
              options={[...gongjongList, { name: '기타', value: '0' }]}
              value={gongjongCd}
              onChange={setGongjongCd}
              placeholder="선택하세요"
              triggerClassName="h-14 rounded-lg border border-[#e2e8f0] bg-slate-50 focus:border-[#FF6B00] focus:ring-2 focus:ring-[#FF6B00]/50"
              selectedOptionClassName="bg-[#FF6B00]/10 text-[#FF6B00]"
            />
            <div className="flex items-start gap-2 rounded-lg border border-[#FF6B00]/20 bg-[#FF6B00]/5 px-3 py-2">
              <span className="material-symbols-outlined mt-0.5 text-sm text-[#FF6B00]">
                info
              </span>
              <p className="text-xs leading-relaxed text-slate-600">
                목록에 없는 공정은{' '}
                <span className="font-semibold text-[#FF6B00]">「기타」</span>를
                선택하고, 장소 항목에 구체적인 내용을 자세히 입력해 주세요.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="flex items-center gap-1 text-sm font-semibold text-slate-700">
              제보일자 <span className="text-[#FF6B00]">*</span>
            </label>
            <Datepicker
              id="nearMiss-reportDate"
              value={reportDate}
              onChange={setReportDate}
              placeholder="날짜 선택 (YYYY-MM-DD)"
              format="yyyy-mm-dd"
              inputClassName="h-14 focus:border-[#FF6B00] focus:ring-2 focus:ring-[#FF6B00]/50"
              iconClassName="text-slate-400 group-focus-within:text-[#FF6B00]"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="flex items-center gap-1 text-sm font-semibold text-slate-700">
              발생일시 <span className="text-[#FF6B00]">*</span>
            </label>
            <Datepicker
              id="nearMiss-occurDate"
              value={occurDate}
              onChange={setOccurDate}
              placeholder="날짜 선택 (YYYY-MM-DD)"
              format="yyyy-mm-dd"
              inputClassName="h-14 focus:border-[#FF6B00] focus:ring-2 focus:ring-[#FF6B00]/50"
              iconClassName="text-slate-400 group-focus-within:text-[#FF6B00]"
            />
            <Timepicker
              id="nearMiss-occurTime"
              value={occurTime}
              onChange={setOccurTime}
              inputClassName="h-14"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="flex items-center gap-1 text-sm font-semibold text-slate-700">
              장소 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="장소를 입력하세요"
              className="h-14 w-full rounded-lg border border-[#e2e8f0] bg-slate-50 px-4 transition-all outline-none focus:border-[#FF6B00] focus:ring-2 focus:ring-[#FF6B00]/50"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="flex items-center gap-1 text-sm font-semibold text-slate-700">
              내용 및 대책 <span className="text-[#FF6B00]">*</span>
            </label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className="min-h-[160px] w-full resize-none rounded-lg border border-[#e2e8f0] bg-slate-50 p-4 transition-all outline-none focus:border-[#FF6B00] focus:ring-2 focus:ring-[#FF6B00]/50"
              placeholder="사고 상황의 구체적인 내용과 재발 방지를 위한 대책을 상세히 입력해 주세요."
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-slate-700">
              사진 첨부
            </label>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              multiple
              className="hidden"
              onChange={(e) => workInfoUpload?.FileChange(e)}
            />
            <div className="grid grid-cols-3 gap-3">
              <button
                type="button"
                onClick={() => {
                  if (photoCount >= MAX_PHOTOS) return;
                  if (Capacitor.isNativePlatform()) {
                    workInfoUpload?.NativeFileChange();
                  } else {
                    fileInputRef.current?.click();
                  }
                }}
                disabled={photoCount >= MAX_PHOTOS}
                className="flex aspect-square flex-col items-center justify-center rounded-lg border-2 border-dashed border-[#e2e8f0] text-slate-400 transition-all hover:border-[#FF6B00]/50 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
              >
                <span className="material-symbols-outlined mb-1 text-3xl">
                  add_a_photo
                </span>
                <span className="text-xs">
                  {photoCount}/{MAX_PHOTOS}
                </span>
              </button>

              {previewList.length > 0 &&
                previewList.map((item, index) => (
                  <div
                    key={index}
                    className="relative aspect-square overflow-hidden rounded-lg border border-[#e2e8f0] bg-slate-100"
                  >
                    <ZoomableImage
                      src={item.preview}
                      alt=""
                      className="h-full w-full object-cover"
                    />
                    <button
                      type="button"
                      onClick={() => workInfoUpload?.DeletePreview(item)}
                      className="absolute top-1 right-1 flex h-6 w-6 items-center justify-center rounded-full bg-black/50 text-white"
                    >
                      <span className="material-symbols-outlined text-sm">
                        close
                      </span>
                    </button>
                  </div>
                ))}
            </div>
            <p className="mt-1 text-xs text-slate-400 italic">
              * 현장 위험 요인이 잘 보이도록 촬영해 주세요.
            </p>
          </div>
        </div>
      </main>

      <footer className="shrink-0 border-t border-[#e2e8f0] bg-white p-4">
        <button
          type="button"
          onClick={() =>
            Save1({
              nearMissSeq: detailItem?.nearMissSeq ?? null,
              gongjongCd,
              reportDate,
              occurDate: `${occurDate} ${occurTime}`,
              location,
              content,
              workCd,
              gubun: '2',
            })
          }
          className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#FF6B00] py-4 font-bold text-white shadow-lg shadow-[#FF6B00]/25 transition-all hover:bg-orange-600 active:scale-[0.98]"
        >
          <span className="material-symbols-outlined">send</span>
          제보하기
        </button>
      </footer>

      {bottomSheetState.type === 'backClickWor' && <BackClickBottomSheet />}
    </div>
  );
}
